import { createSlice } from '@reduxjs/toolkit';

interface MaterialState {
	addMaterialOrderModalVisible: boolean;
	addMaterialModalVisible: boolean;
	addVendorMaterialModalVisible: boolean;
}

const initialState: MaterialState = {
	addMaterialOrderModalVisible: false,
	addVendorMaterialModalVisible: false,
	addMaterialModalVisible: false,
};

export const material = createSlice({
	name: 'material',
	initialState,
	reducers: {
		showAddMaterialOrderModal: (state) => {
			state.addMaterialOrderModalVisible = true;
		},
		closeAddMaterialOrderModal: (state) => {
			state.addMaterialOrderModalVisible = false;
		},
		showAddVendorMaterialModal: (state) => {
			state.addVendorMaterialModalVisible = true;
		},
		closeAddVendorMaterialModal: (state) => {
			state.addVendorMaterialModalVisible = false;
		},
		showAddMaterialModal: (state) => {
			state.addMaterialModalVisible = true;
		},
		closeAddMaterialModal: (state) => {
			state.addMaterialModalVisible = false;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	showAddMaterialOrderModal,
	closeAddMaterialOrderModal,
	showAddVendorMaterialModal,
	closeAddVendorMaterialModal,
	showAddMaterialModal,
	closeAddMaterialModal,
} = material.actions;

export default material.reducer;
